'use strict';

/**
 * «Les alle vurderingene» in a popup (Knut 2026-10-10): sections/pippei-reviews.liquid and sections/store-reviews.liquid.
 *
 * A link with data-review-all keeps its normal href (the portal's list page, which also stays the fallback and is what search engines follow). A plain
 * click opens a <dialog> instead. The list comes from the same portal address with format=json (GET, same origin through the Shopify app proxy, public,
 * no sign-in): {reviews: [...10 newest...], summary: {count, rating}, next: <id or null>}, and «Vis flere» asks for the next ten with before=<next>.
 * Everything is drawn with DOM calls and textContent only: nothing from the server is ever put in as HTML. Anything unexpected (no JSON, an error status,
 * no <dialog>) sends the visitor to the normal page. The dialog uses the chrome of the write popup (.rw*, assets/reviews-write.js) and the review card
 * styles (.rv-card, .pp-stars). The «Skriv en vurdering» button at the bottom is a copy of the one in the section, so it behaves the same (popup or login).
 */
(function () {
  if (window.PippeiReviewsAll) return;   /* several sections on one page load this file once each */
  window.PippeiReviewsAll = true;
  var dlg = null, body = null, title = null, opener = null, link = null;
  var cache = {};
  var root = document.documentElement;
  var CATS = { webshop: 'Nettbutikk', delivery: 'Levering', service: 'Service' };

  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] !== null && attrs[k] !== undefined) n.setAttribute(k, attrs[k]); });
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  function num(v) { return (Math.round(Number(v) * 10) / 10).toFixed(1).replace('.', ','); }
  function date(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(s || ''));
    return m ? m[3] + '.' + m[2] + '.' + m[1] : '';
  }
  function jsonUrl(href, before) {
    var u = new URL(href, window.location.origin);
    u.searchParams.set('format', 'json');
    if (before) u.searchParams.set('before', String(before)); else u.searchParams.delete('before');
    return u.pathname + u.search;
  }
  function fetchPage(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (res) {
      if ((res.headers.get('content-type') || '').indexOf('json') === -1 || res.status >= 400) throw new Error('bad answer');
      return res.json();
    }).then(function (data) {
      if (!data || !Array.isArray(data.reviews)) throw new Error('bad data');
      cache[url] = data;
      return data;
    });
  }

  function cleanup() {
    root.classList.remove('pk-lock');
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }
  function closeDlg() { if (dlg && dlg.open) dlg.close(); cleanup(); }

  function ensureDialog(heading) {
    if (!dlg) {
      dlg = el('dialog', { class: 'rw ra', 'aria-labelledby': 'ra-title' });
      var box = el('div', { class: 'rw__box' });
      var head = el('div', { class: 'rw__head' });
      title = el('h2', { id: 'ra-title', class: 'rw__title' });
      var close = el('button', { type: 'button', class: 'rw__close', 'aria-label': 'Lukk' }, '×');
      close.addEventListener('click', closeDlg);
      head.appendChild(title);
      head.appendChild(close);
      body = el('div', { class: 'rw__body', 'aria-live': 'polite' });
      box.appendChild(head);
      box.appendChild(body);
      dlg.appendChild(box);
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) closeDlg();
        var w = e.target.closest && e.target.closest('[data-review-write]');
        if (w) closeDlg();   /* the write popup (assets/reviews-write.js) opens from the same click */
      });
      dlg.addEventListener('close', cleanup);
      document.body.appendChild(dlg);
    }
    title.textContent = heading || 'Vurderinger';
  }

  function card(r) {
    var c = el('article', { class: 'rv-card' });
    var top = el('div', { class: 'rv-card__top' });
    top.appendChild(el('span', { class: 'pp-stars', style: '--pp-stars: ' + (Number(r.rating) * 20) + '%;', role: 'img', 'aria-label': num(r.rating) + ' av 5 stjerner' }));
    var d = date(r.reviewed_at);
    if (d) top.appendChild(el('time', { class: 'rv-card__date' }, d));
    c.appendChild(top);
    if (r.status === 'rejected_public') c.appendChild(el('p', { class: 'ra__status' }, 'Avvist – teller ikke i score'));
    if (r.title) c.appendChild(el('h3', { class: 'rv-card__title' }, r.title));
    if (r.body) c.appendChild(el('p', { class: 'rv-card__body ra__text' }, r.body));
    var cats = r.category_ratings;
    if (typeof cats === 'string') { try { cats = JSON.parse(cats); } catch (e) { cats = null; } }
    if (cats && typeof cats === 'object') {
      var parts = Object.keys(CATS).filter(function (k) { return cats[k]; }).map(function (k) { return CATS[k] + ' ' + cats[k] + '/5'; });
      if (parts.length) c.appendChild(el('p', { class: 'ra__cats' }, parts.join(' · ')));
    }
    var meta = el('p', { class: 'rv-card__meta' });
    meta.appendChild(el('strong', null, r.author || ''));
    if (r.verification === 'purchase') meta.appendChild(el('span', { class: 'rv-verified' }, 'Bekreftet kjøp'));
    c.appendChild(meta);
    if (r.reply) {
      var rep = el('p', { class: 'rv-card__reply' });
      rep.appendChild(el('strong', null, 'Svar fra Pippei: '));
      rep.appendChild(document.createTextNode(r.reply));
      c.appendChild(rep);
    }
    return c;
  }

  function writeButton() {
    var scope = link && link.closest('section');
    var w = (scope && scope.querySelector('.rv-link--solid')) || document.querySelector('.rv-link--solid');
    if (!w) return null;
    var copy = w.cloneNode(true);
    copy.removeAttribute('id');
    return copy;
  }

  function render(first, href) {
    body.textContent = '';
    var sum = first.summary || {};
    if (sum.count > 0 && sum.rating) {
      var s = el('p', { class: 'ra__sum' });
      s.appendChild(el('span', { class: 'ra__num' }, num(sum.rating)));
      s.appendChild(el('span', { class: 'pp-stars', style: '--pp-stars: ' + (Number(sum.rating) * 20) + '%;', role: 'img', 'aria-label': num(sum.rating) + ' av 5 stjerner' }));
      s.appendChild(el('span', { class: 'ra__count' }, sum.count + (sum.count === 1 ? ' vurdering' : ' vurderinger')));
      body.appendChild(s);
    }
    var list = el('div', { class: 'ra__list' });
    body.appendChild(list);
    var foot = el('div', { class: 'ra__foot' });
    body.appendChild(foot);

    function add(page) {
      page.reviews.forEach(function (r) { list.appendChild(card(r)); });
      foot.textContent = '';
      if (page.next) {
        var more = el('button', { type: 'button', class: 'ra__more' }, 'Vis flere');
        more.addEventListener('click', function () {
          more.disabled = true; more.textContent = 'Henter …';
          fetchPage(jsonUrl(href, page.next)).then(add).catch(function () {
            foot.textContent = '';
            var a = el('a', { href: href, class: 'rv-link' }, 'Åpne alle vurderingene på egen side');
            foot.appendChild(el('p', { class: 'rw__msg rw__msg--error', role: 'alert' }, 'Kunne ikke hente flere akkurat nå.'));
            foot.appendChild(a);
          });
        });
        foot.appendChild(more);
      }
      var w = writeButton();
      if (w) { var row = el('p', { class: 'ra__write' }); row.appendChild(w); foot.appendChild(row); }
    }
    add(first);
  }

  function open(a) {
    if (typeof HTMLDialogElement === 'undefined') return false;
    var href = a.getAttribute('href');
    if (!href) return false;
    try { if (window.sessionStorage.getItem('pp-ra-nojson') === '1') return false; } catch (e) { /* no storage */ }
    opener = a; link = a;
    var heading = a.getAttribute('data-ra-title') || 'Vurderinger';
    var slow = window.setTimeout(function () {
      ensureDialog(heading);
      body.textContent = '';
      body.appendChild(el('p', { class: 'rw__msg rw__msg--info', role: 'status' }, 'Henter vurderingene …'));
      if (!dlg.open) { dlg.showModal(); root.classList.add('pk-lock'); }
    }, 350);
    fetchPage(jsonUrl(href)).then(function (data) {
      window.clearTimeout(slow);
      ensureDialog(heading);
      render(data, href);
      if (!dlg.open) { dlg.showModal(); root.classList.add('pk-lock'); }
    }).catch(function () {
      window.clearTimeout(slow);
      try { window.sessionStorage.setItem('pp-ra-nojson', '1'); } catch (e) { /* no storage */ }
      if (dlg && dlg.open) closeDlg();
      window.location.href = href;
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-review-all]');
    if (!a || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    if (open(a)) e.preventDefault();
  });
})();
